export default "__VITE_ASSET__BcFjflAH__"